import React from 'react'
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { TextWrap } from "../../util/showmore";
import { getCallTransferQueue } from "./api";
import { transferCompleted } from "./CallService";
export function TransferCompleted(props) {
  const [showCallTicker, setShowCallTicker] = useState(true);
  const handleClose = () => setShowCallTicker(false);

  const dispatch = useDispatch();
  const queue = getCallTransferQueue();

  return (
    <>
      <div className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec">
        <div className="tmodal-content">
          <div className="add-conference-header">
            <div className="header-content transfer-completed">
              {true && (
                <div className="number-sec">
                  <div className="head-sec-title">
                    {props.callFlow.getCustomerName()}
                  </div>
                  <div className="head-sec-detail">
                    {props.callFlow.getCustomerNumber()}
                  </div>
                </div>
              )}
              <div style={{ display: "flex" }}>
                {queue && (
                  <div className="queue-sec">
                    <div className="head-sec-title">Queue:</div>
                    <div className="head-sec-detail">
                      <TextWrap
                        text={queue.name}
                        max={props.isMobile ? 10 : 12}
                      />
                    </div>
                  </div>
                )}
                <div className="click-icon" onClick={handleClose}>
                  <img
                    alt=""
                    className="header-close-icon"
                    src={toAbsoluteUrl("/media/sr/icons/close-red.svg")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="initiated-conference-title-sec">
            <div className="head-title-label">Call Transfer</div>
            <div className="voice-indicator">
              <img
                alt=""
                className="voice-indicator-icon"
                src={toAbsoluteUrl("/media/sr/icons/voice-indicator-green.svg")}
              />
            </div>
          </div>
          <div className="tmodal-body">
            <div className="intitiated-sec">
              <div className="row justify-content-center completed-indicator-sec">
                <div className="completed-indicator">
                  <img
                    alt=""
                    className="completed-indicator-icon"
                    src={toAbsoluteUrl("/media/sr/icons/completed-tick.svg")}
                  />
                </div>
              </div>
              <div className="row justify-content-center intitiated-text">
                Queue Transfer Completed
              </div>
              <div className="row justify-content-center another-call-btn-sec ">
                <button
                  type="button"
                  className="btn btn-sm cancel-btn"
                  onClick={() => {
                    transferCompleted(props.callFlow, dispatch);
                  }}
                >
                  <span className="cancel-btn-text">Make Another Call</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
